export default "__VITE_ASSET__Xo9wzgEB__"